import { useEffect, useLayoutEffect } from 'react'

export const useLayoutEffectSSR = typeof window !== 'undefined' ? useLayoutEffect : useEffect
